import React, { useState } from "react";
import QuickStatusModal from "../HotelPage/StatusChange/QuickStatusModal";

export const ROOM_TAG_OPTIONS = [
  { value: "Expérience", label: "Expérience", description: "Chambre équipée version Expérience", color: "bg-[#E9E8E8] text-gray-800" },
  { value: "Essentiel", label: "Essentiel", description: "Chambre équipée version Essentielle", color: "bg-[#E6CFF2] text-purple-900" },
  { value: "Témoin", label: "Témoin", description: "Chambre témoin (référence)", color: "bg-[#0A53A8] text-white" },
  { value: "Aucun", label: "Aucun", description: "Pas de type défini", color: "bg-gray-100 text-gray-800" },
];

export const getRoomTagBadgeClass = (rTag) => {
  const option = ROOM_TAG_OPTIONS.find((opt) => opt.value === rTag);
  return option ? option.color : "bg-gray-100 text-gray-800";
};

/**
 * Badge cliquable pour changer le type de chambre LS (rTag) à la volée,
 * à l'instar de ClickableStatus pour le statut du module.
 */
const ClickableRoomTag = ({ room, onTagChange }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });

  const currentTag = room.rTag || "Aucun";

  const handleTagClick = (e) => {
    e.stopPropagation();

    const rect = e.currentTarget.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

    setModalPosition({
      top: rect.bottom + scrollTop,
      left: rect.left + scrollLeft,
    });

    setIsModalOpen(true);
  };

  const handleTagChange = async (newTag) => {
    try {
      await onTagChange(room.rId, newTag);
    } catch (error) {
      console.error("Erreur lors du changement de type de chambre:", error);
    }
  };

  return (
    <>
      <button
        onClick={handleTagClick}
        className={`
          inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium transition-all duration-150
          ${getRoomTagBadgeClass(currentTag)}
          hover:shadow-sm hover:scale-105 cursor-pointer
        `}
        title="Cliquer pour changer le type de chambre"
      >
        {currentTag}
        <svg className="ml-1 w-3 h-3 opacity-60" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      <QuickStatusModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        currentStatus={currentTag}
        onStatusChange={handleTagChange}
        room={{ ...room, room_nb: room.room_nb ?? room.rRoomNumber }}
        position={modalPosition}
        availableStatuses={ROOM_TAG_OPTIONS}
        modalTitle="Changer le type de chambre"
      />
    </>
  );
};

export default ClickableRoomTag;
